export default __webpack_public_path__ + "static/media/cases2.979f90d7.webp";